// export this package's api
import TweenOne from './TweenOne';
import group from './TweenOneGroup';
import _easing from './easing';
import _plugins from './plugins';
import _ticker from './ticker';

TweenOne.TweenOneGroup = group;
TweenOne.easing = _easing;
TweenOne.plugins = _plugins;
TweenOne.ticker = _ticker;

export default TweenOne;

export var TweenOneGroup = group;

export var easing = _easing;

export var plugins = _plugins;

export var ticker = _ticker;


//////////////////
// WEBPACK FOOTER
// /opt/build/repo/node_modules/rc-tween-one/es/index.js
// module id = 212
// module chunks = 4